import withStyles from '@material-ui/core/styles/withStyles'

const Global = withStyles((theme) => ({
  '@global': {
    // Define any global styles/classes here
    body: {
      overflowY: 'auto',
    },

    'body, #root': {
      height: '100vh',
    },

    'body[style*="overflow: hidden;"]': {
      // paddingRight: theme.spacing(1),
    },

    '::-webkit-scrollbar': {
      width: theme.spacing(1),
      height: theme.spacing(1),
    },

    '::-webkit-scrollbar-track': {
      borderRadius: theme.shape.radius8,
      background: theme.palette.trunkrs.grayscale.lighter,
    },

    '::-webkit-scrollbar-thumb': {
      borderRadius: theme.shape.radius8,
      background: theme.palette.trunkrs.grayscale.base,
    },

    '::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.trunkrs.grayscale.darker,
    },

    '::placeholder': {
      color: theme.palette.trunkrs.grayscale.base,
    },
  },
}))(() => null)

export default Global
